import React from 'react'
import { RiCloseFill } from 'react-icons/ri'
import '../../modal.css'


const Modal = ({ show, onClose, children, showClose = true }) => {
    return (
        <div className={`model-wrapper ${show ? 'show' : null}`}>
            <div className={`modal`}>
                <div className='modal-content'>
                   {showClose && <button className='modal-close-btn link' onClick={onClose}>
                        <RiCloseFill />
                    </button>}
                    <div className='modal-body'>
                    {children}
                    </div>
                </div>
            </div>
            <div className={`modal-overlay`}></div>
        </div>
    )
}

export default Modal